import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { supabase } from '../supabaseClient';

const WaIcon = ({ size = 6 }) => (
  <svg className={`w-${size} h-${size}`} fill="currentColor" viewBox="0 0 24 24">
    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
  </svg>
);

const IgIcon = ({ size = 5 }) => (
  <svg className={`w-${size} h-${size}`} fill="currentColor" viewBox="0 0 24 24">
    <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
  </svg>
);

const FbIcon = ({ size = 5 }) => (
  <svg className={`w-${size} h-${size}`} fill="currentColor" viewBox="0 0 24 24">
    <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
  </svg>
);

const TtIcon = ({ size = 5 }) => (
  <svg className={`w-${size} h-${size}`} fill="currentColor" viewBox="0 0 24 24">
    <path d="M12.525.02c1.31-.02 2.61-.01 3.91-.02.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.05-2.89-.35-4.2-.97-.57-.26-1.1-.59-1.62-.93-.01 2.92.01 5.84-.02 8.75-.08 1.4-.54 2.79-1.35 3.94-1.31 1.92-3.58 3.17-5.91 3.21-1.43.08-2.86-.31-4.08-1.03-2.02-1.19-3.44-3.37-3.65-5.71-.02-.5-.03-1-.01-1.49.18-1.9 1.12-3.72 2.58-4.96 1.66-1.44 3.98-2.13 6.15-1.72.02 1.48-.04 2.96-.04 4.44-.99-.32-2.15-.23-3.02.37-.63.41-1.11 1.04-1.36 1.75-.21.51-.15 1.07-.14 1.61.24 1.64 1.82 3.02 3.5 2.87 1.12-.01 2.19-.66 2.77-1.61.19-.33.4-.67.41-1.06.1-1.79.06-3.57.07-5.36.01-4.03-.01-8.05.02-12.07z"/>
  </svg>
);

const ALL_SERVICES = [
  // ── Automotriz ──────────────────────────────────────────────────────────────
  { id: 'mantenimiento', icon: '🔧', title: 'Mantenimiento Preventivo', desc: 'Cambio de aceite, filtros y revision general.' },
  { id: 'mecanica',      icon: '⚙️', title: 'Mecanica General',         desc: 'Motor, transmision, frenos y suspension.' },
  { id: 'electrico',     icon: '⚡', title: 'Sistema Electrico',         desc: 'Diagnostico computarizado y reparacion electrica.' },
  { id: 'aireacond',     icon: '❄️', title: 'Aire Acondicionado',        desc: 'Carga de gas, limpieza y reparacion del sistema.' },
  { id: 'diagnostico',   icon: '🔍', title: 'Diagnostico Profesional',   desc: 'Scanner avanzado para deteccion de fallas.' },
  { id: 'lavado',        icon: '✨', title: 'Lavado y Detailing',         desc: 'Limpieza interior y exterior con productos premium.' },
  { id: 'alineacion',    icon: '🎯', title: 'Alineacion y Balanceo',      desc: 'Correccion de angulos y equilibrio de ruedas.' },
  { id: 'llantas',       icon: '🔵', title: 'Llantas y Rines',            desc: 'Venta, montaje y reparacion de llantas.' },
  { id: 'latoneria',     icon: '🎨', title: 'Latoneria y Pintura',        desc: 'Reparacion de golpes y pintura profesional.' },
  { id: 'frenos',        icon: '🛑', title: 'Sistema de Frenos',          desc: 'Pastillas, discos, liquido y calibradores.' },
  { id: 'transmision',   icon: '🔩', title: 'Transmision',                desc: 'Caja automatica, mecanica y diferencial.' },
  { id: 'suspension',    icon: '🚗', title: 'Suspension y Direccion',     desc: 'Amortiguadores, rotulas y direccion hidraulica.' },
  { id: 'vidrios',       icon: '🪟', title: 'Vidrios y Polarizado',       desc: 'Instalacion y reparacion de vidrios.' },
  { id: 'escape',        icon: '💨', title: 'Escape y Turbo',             desc: 'Sistema de escape, catalizadores y turbo.' },
  { id: 'bateria',       icon: '🔋', title: 'Baterias',                   desc: 'Venta, carga y mantenimiento de baterias.' },
  // ── Belleza y estetica ──────────────────────────────────────────────────────
  { id: 'corte',         icon: '✂️', title: 'Corte y Peinado',            desc: 'Cortes modernos, peinados y tratamientos capilares.' },
  { id: 'tinte',         icon: '🎨', title: 'Tinte y Coloracion',         desc: 'Coloracion, mechas, balayage y tratamientos.' },
  { id: 'manicure',      icon: '💅', title: 'Manicure y Pedicure',        desc: 'Unas naturales, acrilicas, gel y nail art.' },
  { id: 'facial',        icon: '🧖', title: 'Facial y Limpieza',          desc: 'Limpiezas faciales, hidratacion y tratamientos.' },
  { id: 'depilacion',    icon: '🌸', title: 'Depilacion',                 desc: 'Cera, laser y hilo para todo tipo de piel.' },
  { id: 'masaje',        icon: '💆', title: 'Masajes',                    desc: 'Relajantes, descontracturantes y terapeuticos.' },
  { id: 'maquillaje',    icon: '💄', title: 'Maquillaje',                 desc: 'Social, novias, eventos y cursos.' },
  { id: 'cejas',         icon: '👁️', title: 'Cejas y Pestanas',           desc: 'Diseno de cejas, laminado y extensiones.' },
  // ── Salud y bienestar ──────────────────────────────────────────────────────
  { id: 'consulta',      icon: '🩺', title: 'Consulta Medica',            desc: 'Atencion medica general y especializada.' },
  { id: 'odontologia',   icon: '🦷', title: 'Odontologia',                desc: 'Limpiezas, blanqueamiento y ortodoncia.' },
  { id: 'psicologia',    icon: '🧠', title: 'Psicologia',                 desc: 'Sesiones individuales, de pareja y grupales.' },
  { id: 'nutricion',     icon: '🥗', title: 'Nutricion',                  desc: 'Planes alimenticios y seguimiento personalizado.' },
  { id: 'fisioterapia',  icon: '🏃', title: 'Fisioterapia',               desc: 'Rehabilitacion, lesiones deportivas y posturas.' },
  { id: 'laboratorio',   icon: '🔬', title: 'Laboratorio',                desc: 'Examenes, muestras y resultados en linea.' },
  // ── Fitness y deporte ──────────────────────────────────────────────────────
  { id: 'gym_clase',     icon: '🏋️', title: 'Clases Grupales',           desc: 'Funcional, spinning, yoga, zumba y mas.' },
  { id: 'personal',      icon: '👊', title: 'Personal Training',          desc: 'Entrenamiento personalizado con seguimiento.' },
  { id: 'pilates',       icon: '🧘', title: 'Pilates y Yoga',             desc: 'Clases para todos los niveles, online y presencial.' },
  { id: 'evaluacion',    icon: '📋', title: 'Evaluacion Fisica',          desc: 'Composicion corporal, rendimiento y objetivos.' },
  // ── Veterinaria ────────────────────────────────────────────────────────────
  { id: 'vet_consulta',  icon: '🐾', title: 'Consulta Veterinaria',       desc: 'Atencion general y preventiva para tu mascota.' },
  { id: 'vacuna',        icon: '💉', title: 'Vacunacion',                 desc: 'Plan completo de vacunas con carnet digital.' },
  { id: 'peluqueria_pet',icon: '🐶', title: 'Peluqueria Canina',          desc: 'Bano, corte y arreglo para perros y gatos.' },
  { id: 'cirugia',       icon: '🏥', title: 'Cirugia y Hospitalizacion',  desc: 'Procedimientos quirurgicos y cuidado post.' },
  // ── Restaurante y cafeteria ────────────────────────────────────────────────
  { id: 'desayuno',      icon: '🍳', title: 'Desayunos',                  desc: 'Menu de desayuno con opciones clasicas y especiales.' },
  { id: 'almuerzo',      icon: '🍽️', title: 'Almuerzos',                  desc: 'Platos del dia, especiales y menu ejecutivo.' },
  { id: 'cena',          icon: '🌮', title: 'Cenas',                      desc: 'Menu nocturno con opciones gourmet y casual.' },
  { id: 'domicilio',     icon: '🛵', title: 'Domicilios',                 desc: 'Pedidos a domicilio rapidos y con rastreo.' },
  { id: 'evento',        icon: '🎉', title: 'Eventos y Reservas',         desc: 'Alquiler de salon, catering y organizacion.' },
  // ── Tecnologia y servicios ────────────────────────────────────────────────
  { id: 'soporte_tech',  icon: '💻', title: 'Soporte Tecnico',            desc: 'Reparacion de equipos, redes y software.' },
  { id: 'desarrollo',    icon: '🖥️', title: 'Desarrollo Web',             desc: 'Sitios web, apps y soluciones digitales a medida.' },
  { id: 'instalacion',   icon: '🔌', title: 'Instalacion de Equipos',     desc: 'Camaras, redes, servidores y dispositivos.' },
  { id: 'capacitacion',  icon: '📚', title: 'Capacitacion',               desc: 'Cursos, talleres y formacion empresarial.' },
  // ── Educacion y academia ──────────────────────────────────────────────────
  { id: 'clase_particular', icon: '📖', title: 'Clases Particulares',     desc: 'Refuerzo escolar, idiomas y materias especializadas.' },
  { id: 'musica',        icon: '🎸', title: 'Clases de Musica',           desc: 'Guitarra, piano, voz y teoria musical.' },
  { id: 'idiomas',       icon: '🌍', title: 'Idiomas',                    desc: 'Ingles, frances, aleman y mas con profesores nativos.' },
  // ── Hogar y construccion ──────────────────────────────────────────────────
  { id: 'plomeria',      icon: '🚰', title: 'Plomeria',                   desc: 'Fugas, instalaciones y mantenimiento de tuberias.' },
  { id: 'electrico_hog', icon: '💡', title: 'Electricidad',               desc: 'Instalaciones, reparaciones y certificados.' },
  { id: 'pintura_hog',   icon: '🖌️', title: 'Pintura',                    desc: 'Interiores, exteriores y acabados decorativos.' },
  { id: 'cerrajeria',    icon: '🔑', title: 'Cerrajeria',                 desc: 'Cambio de chapas, duplicado de llaves y apertura.' },
];

const PLATFORM_FEATURES = [
  { icon: '📅', title: 'Agenda Online',          desc: 'Tus clientes reservan en segundos, sin llamadas ni mensajes.' },
  { icon: '👥', title: 'Clientes y CRM',          desc: 'Historial completo, notas y seguimiento de cada cliente.' },
  { icon: '📊', title: 'Reportes en Tiempo Real', desc: 'Ingresos, tendencias y metricas desde cualquier dispositivo.' },
  { icon: '💬', title: 'WhatsApp Automatico',     desc: 'Recordatorios y confirmaciones sin mover un dedo.' },
  { icon: '🗂️', title: 'Control de Inventario',  desc: 'Productos, materiales y alertas de stock bajas.' },
  { icon: '💳', title: 'Facturacion Digital',     desc: 'Genera facturas y recibe pagos al instante.' },
];

const hexToRgb = (hex) => {
  const r = parseInt(hex.slice(1, 3), 16);
  const g = parseInt(hex.slice(3, 5), 16);
  const b = parseInt(hex.slice(5, 7), 16);
  return `${r}, ${g}, ${b}`;
};

const WorkshopLanding = () => {
  const { slug } = useParams();
  const [workshop, setWorkshop] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchWorkshopData = async () => {
      try {
        const { data, error } = await supabase
          .from('workshops')
          .select('*')
          .eq('slug', slug)
          .single();
        if (error) throw error;
        setWorkshop(data);
      } catch (error) {
        console.error('Error cargando datos:', error.message);
      } finally {
        setLoading(false);
      }
    };
    fetchWorkshopData();
  }, [slug]);

  if (loading) return (
    <div style={{ minHeight: '100vh', background: 'linear-gradient(135deg, #070714 0%, #0f0a1e 100%)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <div style={{ textAlign: 'center' }}>
        <div style={{ width: 48, height: 48, borderRadius: '50%', border: '3px solid rgba(139,92,246,0.3)', borderTopColor: '#8b5cf6', animation: 'spin 0.8s linear infinite', margin: '0 auto 16px' }} />
        <p style={{ color: 'rgba(255,255,255,0.6)', fontSize: 15 }}>Cargando...</p>
      </div>
      <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
    </div>
  );

  if (!workshop) return (
    <div style={{ minHeight: '100vh', background: 'linear-gradient(135deg, #070714 0%, #0f0a1e 100%)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <p style={{ color: 'rgba(255,255,255,0.5)' }}>Pagina no encontrada.</p>
    </div>
  );

  const primary   = workshop.brand_color_primary   || '#7c3aed';
  const secondary = workshop.brand_color_secondary || '#a78bfa';
  const agendaUrl = `https://agenda.filtrosyaceitesjm.com/login?workshopId=${workshop.id}`;
  const waNum     = workshop.whatsapp ? workshop.whatsapp.replace(/\D/g, '') : null;
  const waUrl     = waNum ? `https://wa.me/${waNum}` : null;
  const fmt       = (t) => t ? t.slice(0, 5) : '';

  const rgbPrimary   = hexToRgb(primary);
  const rgbSecondary = hexToRgb(secondary);

  const savedIds = Array.isArray(workshop.services) && workshop.services.length > 0
    ? workshop.services : null;
  const SERVICES = savedIds
    ? ALL_SERVICES.filter(s => savedIds.includes(s.id))
    : ALL_SERVICES.slice(0, 6);

  const count = SERVICES.length;
  const gridClass = count <= 3
    ? 'grid-cols-1 sm:grid-cols-3'
    : count <= 6
      ? 'grid-cols-2 md:grid-cols-3'
      : count <= 9
        ? 'grid-cols-2 md:grid-cols-3 lg:grid-cols-3'
        : 'grid-cols-2 md:grid-cols-4 lg:grid-cols-5';

  return (
    <div id="ws-root" style={{ minHeight: '100vh', fontFamily: 'system-ui, -apple-system, sans-serif', background: 'linear-gradient(135deg, #07071a 0%, #0d0a20 50%, #07071a 100%)', color: '#fff', position: 'relative', overflow: 'hidden' }}>

      {/* ── ESTILOS GLOBALES ── */}
      <style>{`
        html { scroll-behavior: smooth; }
        * { box-sizing: border-box; margin: 0; padding: 0; }

        @keyframes spin { to { transform: rotate(360deg); } }
        @keyframes float1 {
          0%, 100% { transform: translateY(0px) translateX(0px); }
          33% { transform: translateY(-30px) translateX(20px); }
          66% { transform: translateY(15px) translateX(-15px); }
        }
        @keyframes float2 {
          0%, 100% { transform: translateY(0px) translateX(0px); }
          50% { transform: translateY(25px) translateX(-20px); }
        }
        @keyframes float3 {
          0%, 100% { transform: translateY(0px); }
          50% { transform: translateY(-20px); }
        }
        @keyframes pulse-glow {
          0%, 100% { opacity: 1; }
          50% { opacity: 0.5; }
        }
        @keyframes slide-up {
          from { opacity: 0; transform: translateY(30px); }
          to   { opacity: 1; transform: translateY(0); }
        }
        @keyframes bounce-down {
          0%, 100% { transform: translateY(0); }
          50% { transform: translateY(8px); }
        }

        .ws-glass {
          background: rgba(255, 255, 255, 0.05);
          backdrop-filter: blur(20px);
          -webkit-backdrop-filter: blur(20px);
          border: 1px solid rgba(255, 255, 255, 0.10);
        }
        .ws-glass-strong {
          background: rgba(255, 255, 255, 0.08);
          backdrop-filter: blur(30px);
          -webkit-backdrop-filter: blur(30px);
          border: 1px solid rgba(255, 255, 255, 0.14);
        }
        .ws-glass-card {
          background: rgba(255, 255, 255, 0.04);
          backdrop-filter: blur(16px);
          -webkit-backdrop-filter: blur(16px);
          border: 1px solid rgba(255, 255, 255, 0.08);
          border-radius: 20px;
          transition: all 0.3s ease;
        }
        .ws-glass-card:hover {
          background: rgba(255, 255, 255, 0.08);
          border-color: rgba(${rgbSecondary}, 0.35);
          box-shadow: 0 8px 40px rgba(${rgbSecondary}, 0.15), 0 0 0 1px rgba(${rgbSecondary}, 0.1);
          transform: translateY(-4px);
        }

        .ws-nav {
          background: rgba(7, 7, 26, 0.75);
          backdrop-filter: blur(24px);
          -webkit-backdrop-filter: blur(24px);
          border-bottom: 1px solid rgba(255, 255, 255, 0.07);
        }

        .ws-btn-primary {
          background: linear-gradient(135deg, ${primary}, ${secondary});
          border: 1px solid rgba(${rgbSecondary}, 0.4);
          box-shadow: 0 4px 24px rgba(${rgbSecondary}, 0.35);
          transition: all 0.2s ease;
        }
        .ws-btn-primary:hover {
          box-shadow: 0 8px 32px rgba(${rgbSecondary}, 0.55);
          transform: translateY(-1px) scale(1.02);
        }

        .ws-btn-glass {
          background: rgba(255, 255, 255, 0.07);
          backdrop-filter: blur(12px);
          border: 1px solid rgba(255, 255, 255, 0.15);
          transition: all 0.2s ease;
        }
        .ws-btn-glass:hover {
          background: rgba(255, 255, 255, 0.12);
          border-color: rgba(255, 255, 255, 0.25);
        }

        .ws-feature-icon {
          background: linear-gradient(135deg, rgba(${rgbPrimary}, 0.2), rgba(${rgbSecondary}, 0.15));
          border: 1px solid rgba(${rgbSecondary}, 0.2);
          transition: all 0.3s ease;
        }
        .ws-glass-card:hover .ws-feature-icon {
          background: linear-gradient(135deg, rgba(${rgbPrimary}, 0.4), rgba(${rgbSecondary}, 0.3));
          border-color: rgba(${rgbSecondary}, 0.5);
          box-shadow: 0 0 20px rgba(${rgbSecondary}, 0.2);
        }

        .ws-gradient-text {
          background: linear-gradient(135deg, #fff 0%, rgba(${rgbSecondary}, 1) 100%);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
        }

        .ws-accent-line {
          background: linear-gradient(90deg, ${primary}, ${secondary});
        }

        .ws-stat-card {
          background: rgba(255,255,255,0.04);
          backdrop-filter: blur(16px);
          border: 1px solid rgba(255, 255, 255, 0.08);
          border-radius: 16px;
          transition: all 0.3s ease;
        }
        .ws-stat-card:hover {
          border-color: rgba(${rgbSecondary}, 0.3);
          background: rgba(255,255,255,0.07);
        }

        .ws-badge {
          background: rgba(${rgbSecondary}, 0.12);
          border: 1px solid rgba(${rgbSecondary}, 0.25);
          backdrop-filter: blur(10px);
        }

        .ws-cta-glass {
          background: linear-gradient(135deg, rgba(${rgbPrimary}, 0.15) 0%, rgba(${rgbSecondary}, 0.10) 100%);
          backdrop-filter: blur(30px);
          border: 1px solid rgba(${rgbSecondary}, 0.2);
          border-radius: 32px;
        }

        .ws-footer-bg {
          background: rgba(7, 7, 20, 0.95);
          border-top: 1px solid rgba(255, 255, 255, 0.06);
        }

        .ws-tag {
          background: rgba(${rgbSecondary}, 0.10);
          border: 1px solid rgba(${rgbSecondary}, 0.20);
          color: rgba(${rgbSecondary}, 1);
          border-radius: 999px;
          padding: 4px 12px;
          font-size: 11px;
          font-weight: 700;
          letter-spacing: 0.08em;
          text-transform: uppercase;
        }

        .ws-social-btn {
          transition: transform 0.2s, box-shadow 0.2s;
        }
        .ws-social-btn:hover {
          transform: translateY(-2px);
          box-shadow: 0 6px 20px rgba(0,0,0,0.4);
        }

        .ws-divider {
          background: linear-gradient(90deg, transparent, rgba(${rgbSecondary}, 0.3), transparent);
          height: 1px;
        }

        /* Animacion entrada */
        .ws-hero-content {
          animation: slide-up 0.8s ease both;
        }
        .ws-hero-delay {
          animation: slide-up 0.8s ease 0.15s both;
        }
        .ws-hero-delay2 {
          animation: slide-up 0.8s ease 0.30s both;
        }
      `}</style>

      {/* ── BLOBS DE FONDO ── */}
      <div style={{ position: 'fixed', inset: 0, pointerEvents: 'none', zIndex: 0, overflow: 'hidden' }}>
        <div style={{
          position: 'absolute', top: '8%', left: '15%',
          width: 600, height: 600, borderRadius: '50%',
          background: `radial-gradient(circle, rgba(${rgbPrimary}, 0.18) 0%, transparent 65%)`,
          filter: 'blur(60px)',
          animation: 'float1 12s ease-in-out infinite',
        }} />
        <div style={{
          position: 'absolute', bottom: '10%', right: '8%',
          width: 500, height: 500, borderRadius: '50%',
          background: `radial-gradient(circle, rgba(${rgbSecondary}, 0.14) 0%, transparent 65%)`,
          filter: 'blur(60px)',
          animation: 'float2 15s ease-in-out infinite',
        }} />
        <div style={{
          position: 'absolute', top: '45%', left: '55%',
          width: 350, height: 350, borderRadius: '50%',
          background: 'radial-gradient(circle, rgba(99, 102, 241, 0.10) 0%, transparent 65%)',
          filter: 'blur(50px)',
          animation: 'float3 10s ease-in-out infinite',
        }} />
        {/* Grid de puntos decorativos */}
        <div style={{
          position: 'absolute', inset: 0,
          backgroundImage: 'radial-gradient(rgba(255,255,255,0.04) 1px, transparent 1px)',
          backgroundSize: '40px 40px',
        }} />
      </div>

      {/* ── NAV ── */}
      <nav className="ws-nav" style={{ position: 'sticky', top: 0, zIndex: 50 }}>
        <div style={{ maxWidth: 1200, margin: '0 auto', padding: '0 24px', height: 68, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
            <div style={{
              width: 32, height: 32, borderRadius: 10,
              background: `linear-gradient(135deg, ${primary}, ${secondary})`,
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              fontSize: 14, fontWeight: 900, color: '#fff',
              boxShadow: `0 4px 12px rgba(${rgbSecondary}, 0.4)`,
            }}>
              {workshop.name.charAt(0).toUpperCase()}
            </div>
            <span style={{ color: '#fff', fontWeight: 800, fontSize: 17, letterSpacing: '-0.02em' }}>
              {workshop.name}
            </span>
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
            {waUrl && (
              <a href={waUrl} target="_blank" rel="noreferrer"
                className="ws-btn-glass"
                style={{ display: 'none', alignItems: 'center', gap: 8, padding: '8px 18px', borderRadius: 999, color: '#fff', textDecoration: 'none', fontSize: 13, fontWeight: 600 }}
                onMouseEnter={e => e.currentTarget.style.display = 'flex'}
              >
                <WaIcon size={4} /> WhatsApp
              </a>
            )}
            {waUrl && (
              <a href={waUrl} target="_blank" rel="noreferrer"
                className="ws-btn-glass"
                style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '8px 18px', borderRadius: 999, color: '#fff', textDecoration: 'none', fontSize: 13, fontWeight: 600 }}>
                <WaIcon size={4} /> <span style={{ display: 'none' }} className="sm-show">WhatsApp</span>
              </a>
            )}
            <a href={agendaUrl}
              className="ws-btn-primary"
              style={{ padding: '10px 22px', borderRadius: 999, color: '#fff', textDecoration: 'none', fontSize: 13, fontWeight: 800, letterSpacing: '-0.01em' }}>
              Agendar cita →
            </a>
          </div>
        </div>
      </nav>

      {/* ── HERO ── */}
      <section style={{ position: 'relative', zIndex: 1, minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '80px 24px' }}>
        <div style={{ maxWidth: 860, margin: '0 auto', textAlign: 'center' }}>

          {/* Badge */}
          <div className="ws-hero-content" style={{ display: 'inline-flex', alignItems: 'center', gap: 8, marginBottom: 28 }}>
            <span className="ws-badge" style={{ display: 'inline-flex', alignItems: 'center', gap: 8, padding: '8px 18px', borderRadius: 999, fontSize: 13, fontWeight: 600, color: 'rgba(255,255,255,0.85)' }}>
              <span style={{ width: 7, height: 7, borderRadius: '50%', background: '#4ade80', display: 'inline-block', animation: 'pulse-glow 2s ease-in-out infinite' }} />
              {workshop.city} &mdash; Disponible ahora
            </span>
          </div>

          {/* Titulo principal */}
          <h1 className="ws-hero-content ws-gradient-text" style={{ fontSize: 'clamp(2.4rem, 6vw, 4.5rem)', fontWeight: 900, lineHeight: 1.08, letterSpacing: '-0.03em', marginBottom: 10 }}>
            {workshop.hero_title || `Todo lo que tu negocio necesita`}
          </h1>
          <h1 className="ws-hero-delay" style={{ fontSize: 'clamp(2.4rem, 6vw, 4.5rem)', fontWeight: 900, lineHeight: 1.08, letterSpacing: '-0.03em', marginBottom: 28, color: 'rgba(255,255,255,0.9)' }}>
            en un solo lugar.
          </h1>

          <p className="ws-hero-delay" style={{ fontSize: 'clamp(1rem, 2vw, 1.2rem)', color: 'rgba(255,255,255,0.55)', lineHeight: 1.7, marginBottom: 44, maxWidth: 580, margin: '0 auto 44px' }}>
            {workshop.hero_description
              || `Gestiona citas, clientes, inventario y pagos desde un solo lugar. Sin software extra, sin complicaciones, sin mensualidades imposibles.`}
          </p>

          {/* Botones */}
          <div className="ws-hero-delay2" style={{ display: 'flex', flexWrap: 'wrap', gap: 14, justifyContent: 'center', marginBottom: 60 }}>
            <a href={agendaUrl}
              className="ws-btn-primary"
              style={{ padding: '16px 36px', borderRadius: 999, color: '#fff', textDecoration: 'none', fontSize: 16, fontWeight: 900, letterSpacing: '-0.01em' }}>
              Reservar cita online →
            </a>
            {waUrl && (
              <a href={waUrl} target="_blank" rel="noreferrer"
                className="ws-btn-glass"
                style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '16px 32px', borderRadius: 999, color: '#fff', textDecoration: 'none', fontSize: 16, fontWeight: 700 }}>
                <WaIcon size={5} /> Escribir por WhatsApp
              </a>
            )}
          </div>

          {/* Trust badges */}
          <div className="ws-hero-delay2" style={{ display: 'flex', flexWrap: 'wrap', gap: 10, justifyContent: 'center' }}>
            {['Sin contratos', 'Todo digital', 'Soporte incluido', '100% tu marca'].map(tag => (
              <span key={tag} className="ws-tag">{tag}</span>
            ))}
          </div>

          {/* Scroll indicator */}
          <div style={{ marginTop: 64, color: 'rgba(255,255,255,0.2)', fontSize: 20, animation: 'bounce-down 2s ease-in-out infinite' }}>↓</div>
        </div>

        {/* Tarjetas flotantes decorativas */}
        <div style={{ position: 'absolute', left: '4%', top: '30%', animation: 'float3 8s ease-in-out infinite', zIndex: -1, display: 'none' }} className="lg-show">
          <div className="ws-glass" style={{ borderRadius: 16, padding: '14px 18px', minWidth: 160 }}>
            <div style={{ fontSize: 11, color: 'rgba(255,255,255,0.4)', marginBottom: 6, fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.08em' }}>Citas hoy</div>
            <div style={{ fontSize: 26, fontWeight: 900, color: '#fff' }}>12 <span style={{ fontSize: 13, color: '#4ade80', fontWeight: 700 }}>+3</span></div>
          </div>
        </div>
        <div style={{ position: 'absolute', right: '4%', top: '25%', animation: 'float1 10s ease-in-out infinite', zIndex: -1, display: 'none' }} className="lg-show">
          <div className="ws-glass" style={{ borderRadius: 16, padding: '14px 18px', minWidth: 170 }}>
            <div style={{ fontSize: 11, color: 'rgba(255,255,255,0.4)', marginBottom: 6, fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.08em' }}>Ingresos del mes</div>
            <div style={{ fontSize: 22, fontWeight: 900, color: '#fff' }}>$4.2M <span style={{ fontSize: 12, color: '#4ade80' }}>↑ 18%</span></div>
          </div>
        </div>
      </section>

      {/* ── NICHOS ── */}
      <section style={{ position: 'relative', zIndex: 1, padding: '0 24px 72px' }}>
        <div style={{ maxWidth: 900, margin: '0 auto', textAlign: 'center' }}>
          <p style={{ fontSize: 12, color: 'rgba(255,255,255,0.3)', fontWeight: 700, letterSpacing: '0.12em', textTransform: 'uppercase', marginBottom: 24 }}>
            Para cualquier tipo de negocio
          </p>
          <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', gap: 10 }}>
            {[
              { icon: '🔧', label: 'Talleres' },
              { icon: '💇', label: 'Salones' },
              { icon: '🩺', label: 'Clinicas' },
              { icon: '🏋️', label: 'Gimnasios' },
              { icon: '🐾', label: 'Veterinarias' },
              { icon: '🍽️', label: 'Restaurantes' },
              { icon: '💻', label: 'Tecnologia' },
              { icon: '📚', label: 'Academias' },
              { icon: '🏠', label: 'Servicios Hogar' },
              { icon: '🛍️', label: 'Tiendas' },
              { icon: '🎨', label: 'Estudios' },
              { icon: '✈️', label: 'Y mucho mas...' },
            ].map(({ icon, label }) => (
              <div key={label} className="ws-glass" style={{
                display: 'flex', alignItems: 'center', gap: 8,
                padding: '10px 18px', borderRadius: 999,
                fontSize: 13, fontWeight: 600, color: 'rgba(255,255,255,0.65)',
              }}>
                <span style={{ fontSize: 16 }}>{icon}</span> {label}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── STATS ── */}
      <section style={{ position: 'relative', zIndex: 1, padding: '0 24px 80px' }}>
        <div style={{ maxWidth: 900, margin: '0 auto', display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))', gap: 16 }}>
          {[
            { val: '100%', sub: 'Tu marca, tu estilo' },
            { val: 'Todo', sub: 'En un solo panel' },
            { val: '0$',   sub: 'Diagnostico inicial' },
            { val: '24/7', sub: 'Acceso desde cualquier parte' },
          ].map((s, i) => (
            <div key={i} className="ws-stat-card" style={{ padding: '20px 16px', textAlign: 'center' }}>
              <div style={{ fontSize: 28, fontWeight: 900, color: secondary, marginBottom: 4 }}>{s.val}</div>
              <div style={{ fontSize: 12, color: 'rgba(255,255,255,0.4)', fontWeight: 500 }}>{s.sub}</div>
            </div>
          ))}
        </div>
      </section>

      {/* ── PLATAFORMA FEATURES ── */}
      <section style={{ position: 'relative', zIndex: 1, padding: '80px 24px' }}>
        <div style={{ maxWidth: 1100, margin: '0 auto' }}>
          <div style={{ textAlign: 'center', marginBottom: 60 }}>
            <div className="ws-tag" style={{ display: 'inline-block', marginBottom: 16 }}>La plataforma</div>
            <h2 style={{ fontSize: 'clamp(1.8rem, 4vw, 2.8rem)', fontWeight: 900, color: '#fff', letterSpacing: '-0.03em', marginBottom: 12, lineHeight: 1.15 }}>
              Todo lo que necesitas,<br />
              <span style={{ color: secondary }}>nada de lo que no.</span>
            </h2>
            <p style={{ color: 'rgba(255,255,255,0.45)', maxWidth: 480, margin: '0 auto', fontSize: 15, lineHeight: 1.7 }}>
              Un sistema pensado para cualquier negocio. Sin curvas de aprendizaje, sin software extra, sin complicaciones.
            </p>
          </div>

          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: 20 }}>
            {PLATFORM_FEATURES.map((f, i) => (
              <div key={i} className="ws-glass-card" style={{ padding: '28px 24px' }}>
                <div className="ws-feature-icon" style={{ width: 52, height: 52, borderRadius: 14, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 24, marginBottom: 18 }}>
                  {f.icon}
                </div>
                <h3 style={{ fontWeight: 800, color: '#fff', fontSize: 16, marginBottom: 8, letterSpacing: '-0.01em' }}>{f.title}</h3>
                <p style={{ color: 'rgba(255,255,255,0.45)', fontSize: 14, lineHeight: 1.65 }}>{f.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── SERVICIOS DEL NEGOCIO ── */}
      {SERVICES.length > 0 && (
        <section style={{ position: 'relative', zIndex: 1, padding: '80px 24px' }}>
          <div style={{ maxWidth: 1100, margin: '0 auto' }}>
            <div style={{ textAlign: 'center', marginBottom: 56 }}>
              <div className="ws-tag" style={{ display: 'inline-block', marginBottom: 16 }}>Lo que ofrecemos</div>
              <h2 style={{ fontSize: 'clamp(1.8rem, 4vw, 2.8rem)', fontWeight: 900, color: '#fff', letterSpacing: '-0.03em', lineHeight: 1.15 }}>
                Nuestros Servicios
              </h2>
            </div>
            <div className={`grid ${gridClass} gap-4`} style={{ display: 'grid', gridTemplateColumns: `repeat(auto-fill, minmax(${count <= 3 ? '220px' : '200px'}, 1fr))`, gap: 16 }}>
              {SERVICES.map((s) => (
                <div key={s.id} className="ws-glass-card" style={{ padding: 24 }}>
                  <div className="ws-feature-icon" style={{ width: 48, height: 48, borderRadius: 12, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 22, marginBottom: 14 }}>
                    {s.icon}
                  </div>
                  <h3 style={{ fontWeight: 700, color: '#fff', fontSize: 14, marginBottom: 6, letterSpacing: '-0.01em' }}>{s.title}</h3>
                  <p style={{ color: 'rgba(255,255,255,0.4)', fontSize: 13, lineHeight: 1.6 }}>{s.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </section>
      )}

      {/* ── CTA CENTRAL ── */}
      <section style={{ position: 'relative', zIndex: 1, padding: '80px 24px' }}>
        <div style={{ maxWidth: 720, margin: '0 auto' }}>
          <div className="ws-cta-glass" style={{ padding: 'clamp(40px, 6vw, 72px) clamp(28px, 5vw, 64px)', textAlign: 'center' }}>
            <div className="ws-tag" style={{ display: 'inline-block', marginBottom: 20 }}>Empieza hoy</div>
            <h2 style={{ fontSize: 'clamp(1.6rem, 3.5vw, 2.4rem)', fontWeight: 900, color: '#fff', letterSpacing: '-0.03em', marginBottom: 14, lineHeight: 1.2 }}>
              Tu negocio merece crecer<br />sin tanto esfuerzo.
            </h2>
            <p style={{ color: 'rgba(255,255,255,0.5)', marginBottom: 36, fontSize: 15, lineHeight: 1.7 }}>
              Agenda en linea en menos de 2 minutos.<br />Sin llamadas, sin formularios interminables.
            </p>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: 12, justifyContent: 'center' }}>
              <a href={agendaUrl}
                className="ws-btn-primary"
                style={{ padding: '15px 36px', borderRadius: 999, color: '#fff', textDecoration: 'none', fontSize: 15, fontWeight: 900, letterSpacing: '-0.01em' }}>
                Reservar mi cita →
              </a>
              {waUrl && (
                <a href={waUrl} target="_blank" rel="noreferrer"
                  className="ws-btn-glass"
                  style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '15px 28px', borderRadius: 999, color: '#fff', textDecoration: 'none', fontSize: 15, fontWeight: 600 }}>
                  <WaIcon size={5} /> Consultar ahora
                </a>
              )}
            </div>
          </div>
        </div>
      </section>

      {/* ── FOOTER ── */}
      <footer className="ws-footer-bg" style={{ position: 'relative', zIndex: 1 }}>
        <div style={{ height: 1, background: `linear-gradient(90deg, transparent, rgba(${rgbSecondary}, 0.4), transparent)` }} />

        <div style={{ maxWidth: 1100, margin: '0 auto', padding: '64px 24px 32px' }}>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))', gap: 48, marginBottom: 56 }}>

            {/* Marca */}
            <div>
              <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 16 }}>
                <div style={{ width: 36, height: 36, borderRadius: 10, background: `linear-gradient(135deg, ${primary}, ${secondary})`, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 16, fontWeight: 900, color: '#fff' }}>
                  {workshop.name.charAt(0).toUpperCase()}
                </div>
                <span style={{ color: '#fff', fontWeight: 800, fontSize: 18, letterSpacing: '-0.02em' }}>{workshop.name}</span>
              </div>
              <p style={{ fontSize: 13, color: 'rgba(255,255,255,0.35)', lineHeight: 1.7, marginBottom: 20 }}>
                {workshop.footer_tagline || `Tu negocio de confianza en ${workshop.city}. Calidad garantizada.`}
              </p>
              {SERVICES.length > 0 && (
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6 }}>
                  {SERVICES.slice(0, 4).map(s => (
                    <span key={s.id} style={{ fontSize: 11, padding: '4px 10px', borderRadius: 999, fontWeight: 600, color: 'rgba(255,255,255,0.5)', background: 'rgba(255,255,255,0.06)', border: '1px solid rgba(255,255,255,0.09)' }}>
                      {s.icon} {s.title.split(' ')[0]}
                    </span>
                  ))}
                  {SERVICES.length > 4 && (
                    <span style={{ fontSize: 11, padding: '4px 10px', borderRadius: 999, fontWeight: 600, color: 'rgba(255,255,255,0.3)', background: 'rgba(255,255,255,0.04)', border: '1px solid rgba(255,255,255,0.07)' }}>
                      +{SERVICES.length - 4}
                    </span>
                  )}
                </div>
              )}
            </div>

            {/* Contacto */}
            <div>
              <h4 style={{ color: '#fff', fontWeight: 700, fontSize: 11, textTransform: 'uppercase', letterSpacing: '0.1em', marginBottom: 20, display: 'flex', alignItems: 'center', gap: 8 }}>
                <span style={{ display: 'inline-block', width: 18, height: 2, background: secondary, borderRadius: 999 }} />
                Contacto
              </h4>
              <ul style={{ listStyle: 'none', display: 'flex', flexDirection: 'column', gap: 12 }}>
                <li style={{ display: 'flex', alignItems: 'center', gap: 10, fontSize: 14, color: 'rgba(255,255,255,0.8)', fontWeight: 600 }}>
                  <span style={{ fontSize: 16 }}>📞</span> {workshop.phone}
                </li>
                <li style={{ display: 'flex', alignItems: 'flex-start', gap: 10, fontSize: 13, color: 'rgba(255,255,255,0.4)' }}>
                  <span style={{ fontSize: 16, marginTop: 1 }}>📍</span> {workshop.address}, {workshop.city}
                </li>
                {workshop.opening_time && (
                  <li style={{ display: 'flex', alignItems: 'center', gap: 10, fontSize: 13, color: 'rgba(255,255,255,0.4)' }}>
                    <span style={{ fontSize: 16 }}>🕐</span> {fmt(workshop.opening_time)} – {fmt(workshop.closing_time)}
                  </li>
                )}
              </ul>
            </div>

            {/* Redes */}
            <div>
              <h4 style={{ color: '#fff', fontWeight: 700, fontSize: 11, textTransform: 'uppercase', letterSpacing: '0.1em', marginBottom: 20, display: 'flex', alignItems: 'center', gap: 8 }}>
                <span style={{ display: 'inline-block', width: 18, height: 2, background: secondary, borderRadius: 999 }} />
                Siguenos
              </h4>
              <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8 }}>
                {waUrl && (
                  <a href={waUrl} target="_blank" rel="noreferrer"
                    className="ws-social-btn"
                    style={{ display: 'inline-flex', alignItems: 'center', gap: 7, padding: '9px 14px', borderRadius: 12, background: '#16a34a', color: '#fff', fontSize: 12, fontWeight: 700, textDecoration: 'none' }}>
                    <WaIcon size={4} /> WhatsApp
                  </a>
                )}
                {workshop.instagram && (
                  <a href={workshop.instagram} target="_blank" rel="noreferrer"
                    className="ws-social-btn"
                    style={{ display: 'inline-flex', alignItems: 'center', gap: 7, padding: '9px 14px', borderRadius: 12, background: 'linear-gradient(45deg, #f09433, #e6683c, #dc2743, #cc2366, #bc1888)', color: '#fff', fontSize: 12, fontWeight: 700, textDecoration: 'none' }}>
                    <IgIcon size={4} /> Instagram
                  </a>
                )}
                {workshop.facebook && (
                  <a href={workshop.facebook} target="_blank" rel="noreferrer"
                    className="ws-social-btn"
                    style={{ display: 'inline-flex', alignItems: 'center', gap: 7, padding: '9px 14px', borderRadius: 12, background: '#1d4ed8', color: '#fff', fontSize: 12, fontWeight: 700, textDecoration: 'none' }}>
                    <FbIcon size={4} /> Facebook
                  </a>
                )}
                {workshop.tiktok && (
                  <a href={workshop.tiktok} target="_blank" rel="noreferrer"
                    className="ws-social-btn"
                    style={{ display: 'inline-flex', alignItems: 'center', gap: 7, padding: '9px 14px', borderRadius: 12, background: '#111', border: '1px solid rgba(255,255,255,0.12)', color: '#fff', fontSize: 12, fontWeight: 700, textDecoration: 'none' }}>
                    <TtIcon size={4} /> TikTok
                  </a>
                )}
              </div>
            </div>
          </div>

          <div style={{ height: 1, background: 'rgba(255,255,255,0.06)', marginBottom: 24 }} />

          <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'space-between', alignItems: 'center', gap: 12 }}>
            <span style={{ fontSize: 12, color: 'rgba(255,255,255,0.25)' }}>
              © {new Date().getFullYear()} {workshop.name} · {workshop.city}, Colombia
            </span>
            <span style={{ fontSize: 12, color: 'rgba(255,255,255,0.25)' }}>
              Potenciado por <span style={{ fontWeight: 800, color: secondary }}>Garaje Pro 360</span>
            </span>
          </div>
        </div>
      </footer>

      {/* ── WhatsApp FAB ── */}
      {waUrl && (
        <a href={waUrl} target="_blank" rel="noreferrer"
          style={{
            position: 'fixed', bottom: 24, right: 24, zIndex: 100,
            width: 56, height: 56, borderRadius: '50%',
            background: 'linear-gradient(135deg, #16a34a, #22c55e)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            color: '#fff', textDecoration: 'none',
            boxShadow: '0 8px 32px rgba(34,197,94,0.45)',
            transition: 'transform 0.2s, box-shadow 0.2s',
          }}
          onMouseEnter={e => { e.currentTarget.style.transform = 'scale(1.12)'; e.currentTarget.style.boxShadow = '0 12px 40px rgba(34,197,94,0.6)'; }}
          onMouseLeave={e => { e.currentTarget.style.transform = 'scale(1)'; e.currentTarget.style.boxShadow = '0 8px 32px rgba(34,197,94,0.45)'; }}
        >
          <WaIcon size={7} />
        </a>
      )}
    </div>
  );
};

export default WorkshopLanding;
